var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('va-create-layout',[_c(_setup.BooksForm,{attrs:{"id":_vm.id,"title":_vm.title,"item":_setup.defaultBook,"is-clone":_setup.isClone,"is-create":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }